export class Astre {
    id!: number;
  }

export class Astres {
    public static Saronide = 14;
    public static PortePeste = 15;
    public static Cannibale = 1;

    public values: Map<number, string> = new Map<number, string>([
        [0, "Myrmidon"],
        [1, "Cannibale"],
        [2, "Pugiliste"],
        [3, "Chevalier"],
        [4, "Ombre"],
        [5, "Braconne"],
        [6, "Malhonnete"],
        [7, "Rhapsode"],
        [8, "Adepte"],
        [9, "Dement"],
        [10, "Saccageur"],
        [11, "Celestaire"],
        [12, "Chaman"],
        [13, "Malemort"],
        [14, "Saronide"],
        [15, "PortePeste"]
    ]);
}